export const EDIT_WORKSPACE_NAME = "edit_workspace";
export const EDIT_WORKSPACE_DESC = `Updates a workspace (organization) name via GraphQL mutation.

Use this when a user asks to rename the current workspace.

Input:
- 'workspaceId' (required): Target workspace/organization ID.
- 'name' (required): New workspace name.

Returns:
- updated workspace { id, name, workspacePath, workspaceUrl? }.`;
